// import styles
import './shared/scss/index.scss';

// import components
import 'components/';

// only available in dev mode
if (process.env.NODE_ENV !== 'production') require('dev/');

// require polyfills
require('loading-attribute-polyfill');
